<template>
  <div>
    <template v-if="standardEdit">
      <el-form-item label="关键词" prop="keywords">
        <el-input style="width: 320px" :value="projectForm.keywordsDesc" readonly placeholder="未添加关键词"></el-input>
        <slot name="searchBidKeywordsSelectBtn"></slot>
      </el-form-item>
    </template>

    <template v-else>
      <el-form-item label="开启" prop="keywordSwitch">
      <el-switch v-model="projectForm.keywordSwitch" :active-value="1" :inactive-value="0"> </el-switch>
    </el-form-item>

    <template v-if="projectForm.keywordSwitch">
      <el-form-item label="关键词" prop="keywordSwitch">
        <el-input style="width: 280px" :value="projectForm.keywordsDesc" readonly placeholder="未添加关键词，待自动更新"></el-input>
        <slot name="searchBidKeywordsSelectBtn"></slot>
      </el-form-item>

      <el-form-item label="出价系数" prop="search_bid_ratio">
        <el-input
          style="width: 280px"
          v-model="projectForm.search_bid_ratio"
          :disabled="projectForm.delivery_setting.bid_type === BID_TYPE.NO_BID"
          placeholder="请输入1.00-2.00之间的值，最多2位小数"
        ></el-input>
        <span v-show="projectForm.delivery_setting.bid_type === BID_TYPE.NO_BID">&ensp;最大转化不能设置出价系数</span>
      </el-form-item>

      <el-form-item label="定向扩展" prop="audience_extend">
        <el-radio-group v-model="projectForm.audience_extend">
          <el-radio-button ghost :label="AUDIENCE_EXTEND.ON">开启</el-radio-button>
          <el-radio-button ghost :label="AUDIENCE_EXTEND.OFF">不开启</el-radio-button>
        </el-radio-group>
      </el-form-item>
      </template>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'

import { AUDIENCE_EXTEND, BID_TYPE } from '../../consts/index.js'

// eslint-disable-next-line
const props = defineProps({
  form: Object,
  standardEdit: {
    type: Boolean,
    default: false
  }
})
const projectForm = computed(() => props.form)
const standardEdit = computed(() => props.standardEdit)
</script>

<style lang="scss" scoped></style>
